import { RouterProvider } from 'react-router-dom';
import './index.css';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { router } from '@/router/router';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
